import React, { useState, useRef } from "react";
import YouTube from "react-youtube";
import { getYoutubeVideoId } from "../../util/util";
import "./VideoTutorials.css"; // Ensure you have the correct CSS file

export const VideoTutorialsComponent = (props) => {
    const options = {
        playerVars: {
            autoplay: 0,
            loop: 0,
            rel: 0,
        },
    };
    const [playingVideoId, setPlayingVideoId] = useState(null);
    const playersRef = useRef({});

    const handleVideoPlay = (event, videoId) => {
        // Pause the currently playing video if any
        if (playingVideoId && playingVideoId !== videoId) {
            playersRef.current[playingVideoId].pauseVideo();
        }
        setPlayingVideoId(videoId);
    };

    const handleVideoEndOrPause = (event, videoId) => {
        if (videoId === playingVideoId) {
            setPlayingVideoId(null);
        }
    };

    const onPlayerReady = (event, videoId) => {
        // Store the player instance in the playersRef
        playersRef.current[videoId] = event.target;
    };

    return (
        <div>
            {props.data.content.map((category, index) => (
                <>
                <div key={index} className="Video-tutorial-header">
                    <p className="Video-tutorial-header">{category.category}</p>
                    <div className="grid-container">
                        {category.videos.map((item, idx) => {
                            const videoId = getYoutubeVideoId(item.videoUrl);
                            const isPlaying = playingVideoId === videoId;
                            return (
                                <div key={idx} className={`overlay-container ${isPlaying ? 'hidden-gradient' : ''}`}>
                                    <div className={`iframe-container ${isPlaying ? 'hidden-gradient' : ''}`}>
                                        <YouTube
                                            id="youtube-container"
                                            onPlay={(event) => handleVideoPlay(event, videoId)}
                                            onPause={(event) => handleVideoEndOrPause(event, videoId)}
                                            onEnd={(event) => handleVideoEndOrPause(event, videoId)}
                                            onReady={(event) => onPlayerReady(event, videoId)}
                                            className={`youtube-container ${isPlaying ? 'hidden-gradient' : ''}`}
                                            opts={options}
                                            videoId={videoId}
                                        />
                                    </div>
                                    <div className={`iframe-overlay ${isPlaying ? 'hidden-gradient' : ''}`}></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                {index !== props.data.content.length - 1 && (
            <hr style={{ margin: "0", padding: "0" }} color="1px solid var(--border-separators-outlines, #e6e7e8)" />
        )}
                </>
            ))}         
        </div>
    );
};
